import UserEditTable from "root/s360components/Tables/UserEditTable";
import {Fragment, useEffect, useState} from "react";
import {getUsersForSchoolByUserType} from "root/DataFunctions/EditUserFns";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import useModalEditUser from "root/s360components/Modals/UserEdit/useModalEditUser";

const EMPTY_DATA = {data: [], isLoading: true}
const UserEditManager = ({encSchoolId, userType}) =>
{
    const [data, setData] = useState(EMPTY_DATA);

    const [renderModalEditUser, activateModalEditUser] = useModalEditUser();

    const filtersExists = encSchoolId !== null && userType !== null && encSchoolId !== undefined && userType !== undefined;

    const getData = () =>
    {
        getUsersForSchoolByUserType(encSchoolId, userType, (response) =>
        {
            setData({data: response.results.record_set, isLoading: false})
        })
    }

    const onClickActivateModalEditUser = (mode, enc_user_id, user_type) =>
    {
        activateModalEditUser(mode, enc_user_id, user_type).then((response) =>
        {
            if (response === 'saved')
            {
                getData();
            }
        })
    }


    useEffect(() =>
    {
        if (filtersExists === true)
        {
            setData(EMPTY_DATA);

            getData();
        }
    }, [encSchoolId, userType])


    const noParamsSelectedSection = () =>
    {
        return (
            <div key='k1'
                 style={{margin: "20px", marginTop: "150px", marginBottom: "150px", textAlign: "center"}}>
                <h4 key='please'>Please select both filters</h4>
            </div>
        )
    }

    const loadingSection = () =>
    {
        return (
            <div className='spinner-with-margin' key={'k2'}>
                <SpinnerDiv/>
            </div>
        )
    }


    return (
        <Fragment key='k3'>
            {(filtersExists === true && data.isLoading === false) &&
                <UserEditTable data={data.data} onClickEdit={onClickActivateModalEditUser}/>}
            {(filtersExists === true && data.isLoading === true) && loadingSection()}

            {(encSchoolId === null || userType === null) && noParamsSelectedSection()}
            <Fragment>
                {renderModalEditUser()}
            </Fragment>
        </Fragment>
    )
}

export default UserEditManager;